import { NestedFilter, GQL_ID } from '@@partner:types:graphql'
import { makeBetweenFilter, makeFilter, makeSearchFilter } from './crud/filters'

export type VehiclesFiltersType = {
  license_plate: string
  status: boolean | null
}

export const prepareVehicleFilter = (filters: VehiclesFiltersType): NestedFilter => {
  const plateFilter = makeSearchFilter('license_plate', 'includes', filters.license_plate)
  const statusFilter = makeFilter('is_active', 'eq', filters.status)

  return {
    and: [
      plateFilter,
      statusFilter
    ]
  }
}